module.exports = __webpack_public_path__ + "img/water.d860f552.jpg";